import { useEffect, useState, useMemo } from "react"
import { Link, useLocation, useParams } from "react-router-dom"
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import StatCard from "./Card";
import LoadingModal from "./Unit/LoadingModal";
import { CheckSquare, Users, Clock, Building2, Earth, Calendar, BellPlus, ConciergeBell, ScanEye, Eye, Calendars, Monitor, Smartphone, Globe, Cog, ArrowBigUp, LucideArrowDown, LucideArrowUp, LucideCalendarClock } from "lucide-react";
import ReactTooltip from 'react-tooltip';
import styles from "./index.module.css";
import stylesReport from "./report.module.css";

export default function GA4({ itemsPerPage = 50, itemsPerPage1 = 10}) {
     const [data, setData] = useState(null);
     const [subData, setSubData] = useState(null);
     const [otherData, setOtherData] = useState(null);
     const [ReservationData, setReservationData] = useState(null);
     const [countryReport, setCountryReport] = useState(null)
     const [cityReport, setCityReport] = useState(null)
     const [realReservation, setRealReservation] = useState(null)
     const [compareData, setCompareData] = useState(null)
     const {t} = useTranslation()
     const [sortType, setSortType] = useState("");
     const [sortType2, setSortType2] = useState("");
     const [propertyID, setPropertyID] = useState("366123786")
     const [isLoading, setIsLoading] = useState(false)
     const [startDate, setStartDate] = useState(() =>
        dayjs().startOf("month").format("YYYY-MM-DD")
      );
      const [endDate, setEndDate] = useState(() =>
        dayjs().format("YYYY-MM-DD")
      );
      const prevStartDate = dayjs(startDate)
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");

    const prevEndDate = dayjs(endDate)
        .subtract(1, "month")
        .format("YYYY-MM-DD");
 const getMetricDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/overview/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setData(responseData.rows)
        setSubData(responseData.totals)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getOtherDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/otherData/${propertyID}?startDate=${dayjs(startDate).format("YYYY-MM-DD")}&endDate=${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setOtherData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getReservationDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/reservations/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setReservationData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getCompareDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/compare/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}/${prevStartDate}/${prevEndDate}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setCompareData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getCountryReportDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/country-report/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setCountryReport(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getCityReportDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/ga4/city-report/${propertyID}/${dayjs(startDate).format("YYYY-MM-DD")}/${dayjs(endDate).format("YYYY-MM-DD")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setCityReport(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 
 const getRealReservationDataGA4 = async () => {
    setIsLoading(true)
    try {
      const response = await fetch(`/api/website/compare/${dayjs(startDate).format("YYYY-MM")}/${dayjs(endDate).subtract(1, 'month').format("YYYY-MM")}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      if(responseData){
        setIsLoading(false) 
        setRealReservation(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
}; 

useEffect(() => {
    if (!startDate || !endDate) return;
      getMetricDataGA4();
      getReservationDataGA4();
      getOtherDataGA4();
      getCountryReportDataGA4()
      getCityReportDataGA4()
      getRealReservationDataGA4()
      getCompareDataGA4()
}, [startDate, endDate, prevStartDate, prevEndDate, propertyID]);


     const [currentPage, setCurrentPage] = useState(1);
     const totalPages = Math.ceil(otherData?.rows?.length / itemsPerPage);
     const currentData = otherData?.rows?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

     
  const goPrev = () => setCurrentPage(p => Math.max(p - 1, 1));
  const goNext = () => setCurrentPage(p => Math.min(p + 1, totalPages));
  
const countMetrics = (dataSource, dimensionIndex) => {
  return dataSource?.rows?.reduce((acc, row) => {
    let keyData = row?.dimensionValues?.[dimensionIndex]?.value

    if (!keyData) return acc

    acc[keyData] = (acc[keyData] || 0) + 1
    return acc;
  }, {});
};

const useMetricStats = (data, dimensionIndex) => {
  return useMemo(() => {
    if (!Array.isArray(data?.rows)) return {};
    return countMetrics(data, dimensionIndex);
  }, [data, dimensionIndex]);
};

const cityStats = useMetricStats(otherData, 2)
const countryStats = useMetricStats(otherData, 1)
const deviceStats = useMetricStats(otherData, 3)
const browserStats = useMetricStats(otherData, 4)
const osStats = useMetricStats(otherData, 5)

const countRestMetric = (dataSource, metricIndex) => {
  return dataSource
  .reduce((sum, row) => {
    const value = Number(row?.metricValues?.[metricIndex]?.value || 0)
    return sum + value
  }, 0)
}

const useRestMetricStats = (data, metricIndex) => {
  return useMemo(() => {
   if (!data?.rows?.length) return 0;
   return countRestMetric(data.rows, metricIndex)
  }, [data, metricIndex])
}
const totals = subData?.[0]?.metricValues
const pageViewCount = Number(totals?.[1]?.value || 0)
const eventCount = Number(totals?.[2]?.value || 0)
const reservationCompleted = useRestMetricStats(ReservationData, 0)
// 0 activeuser, 1 pageview, 2 event, 3 session, 4 totaluser, 5 newuser

  const flatData = useMemo(() => {
  if (!countryReport || typeof countryReport !== "object") return [];

  return Object.values(countryReport).flat();
}, [countryReport]);

const sortedData = useMemo(() => {
  if (!Array.isArray(flatData)) return [];

  let temp = flatData
  .filter(Boolean) 
  .filter(row => row.metricValues?.length >= 2);

  switch (sortType) {
    case "session-asc":
      temp.sort(
        (a, b) =>
          Number(a.metricValues?.[0]?.value || 0) - Number(b.metricValues?.[0]?.value || 0)
      );
      break;

    case "session-desc":
      temp.sort(
        (a, b) =>
          Number(b.metricValues?.[0]?.value || 0) - Number(a.metricValues?.[0]?.value || 0)
      );
      break;

    case "conversion-asc":
      temp.sort(
        (a, b) =>
          Number(a.metricValues?.[1]?.value || 0) - Number(b.metricValues?.[1]?.value || 0)
      );
      break;

    case "conversion-desc":
      temp.sort(
        (a, b) =>
          Number(b.metricValues?.[1]?.value || 0) - Number(a.metricValues?.[1]?.value || 0)
      );
      break;

    default:
      break;
  }

  return temp;
}, [sortType, flatData]);

  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(sortedData?.length / itemsPerPage1);

  const currentData1 = useMemo(() => {
    if (!Array.isArray(sortedData)) return [];

    const start = (currentPage1 - 1) * itemsPerPage1;
    const end = currentPage1 * itemsPerPage1;

    return sortedData.slice(start, end);
}, [sortedData, currentPage1, currentPage1]);
     
  const goPrev1 = () => setCurrentPage1(p => Math.max(p - 1, 1));
  const goNext1 = () => setCurrentPage1(p => Math.min(p + 1, totalPages1));

const flatData2 = useMemo(() => {
  if (!cityReport || typeof cityReport !== "object") return [];

  return Object.values(cityReport).flat();
}, [cityReport]);

const sortedData2 = useMemo(() => {
  if (!Array.isArray(flatData2)) return [];

  let temp = flatData2
  .filter(Boolean) 
  .filter(row => row.metricValues?.length >= 2)
  .filter(row => row.dimensionValues?.[0]?.value !== "(not set)")

  switch (sortType2) {
    case "session-asc":
      temp.sort(
        (a, b) =>
          Number(a.metricValues?.[0]?.value || 0) - Number(b.metricValues?.[0]?.value || 0)
      );
      break;

    case "session-desc":
      temp.sort(
        (a, b) =>
          Number(b.metricValues?.[0]?.value || 0) - Number(a.metricValues?.[0]?.value || 0)
      );
      break;

    case "conversion-asc":
      temp.sort(
        (a, b) =>
          Number(a.metricValues?.[1]?.value || 0) - Number(b.metricValues?.[1]?.value || 0)
      );
      break;

    case "conversion-desc":
      temp.sort(
        (a, b) =>
          Number(b.metricValues?.[1]?.value || 0) - Number(a.metricValues?.[1]?.value || 0)
      );
      break;

      default:
      break;
  }

  return temp;
}, [sortType2, flatData2]);

  
     const [currentPage2, setCurrentPage2] = useState(1);
     const totalPages2 = Math.ceil(sortedData2?.length / itemsPerPage1);

  const currentData2 = useMemo(() => {
    if (!Array.isArray(sortedData2)) return [];

    const start = (currentPage2 - 1) * itemsPerPage1;
    const end = currentPage2 * itemsPerPage1;

    return sortedData2.slice(start, end);
}, [sortedData2, currentPage2, currentPage2]);
     
  const goPrev2 = () => setCurrentPage2(p => Math.max(p - 1, 1));
  const goNext2 = () => setCurrentPage2(p => Math.min(p + 1, totalPages2));

    return (
      <div>
        {/* <MarketingHeader /> */}
     <div style={{ padding: 20, backgroundColor:"#fff" }}>     
        <div className="d-flex ml-3 mt-5">
             <div style={{marginRight: 10, width: 'fit-content'}}>
                   <Flatpickr 
                     value={startDate}
                       options={{
                       dateFormat:'Y-m-d'}} 
                        className={`col-md-12 ${styles.contentBookingDate} ${styles.webkitAppearance}`} 
                         placeholder={t('booking.date_in')} 
                         onChange={(dates)=>{
                         setStartDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                      }} />
             </div>
               <div style={{marginRight: 10, width: 'fit-content'}}>
                    <Flatpickr 
                            value={endDate}
                            options={{
                              minDate: dayjs(startDate).format("YYYY-MM-DD"),
                              dateFormat:'Y-m-d'}} 
                            className={`col-md-12 ${styles.contentBookingDate} ${styles.webkitAppearance}`}
                            placeholder={t('booking.date_out')} 
                            onChange={(dates) =>{
                              setEndDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                            }} />
                            </div>
                             <div style={{marginRight: 10, width: 'fit-content'}}>
                                            <button 
                                            className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                                            onClick={() => {
                                                const lastMonthStart = dayjs(startDate).subtract(1, "month").startOf("month").format("YYYY-MM-DD");
                                                const lastMonthEnd = dayjs(endDate).subtract(1, "month").endOf("month").format("YYYY-MM-DD");
                                              setStartDate(lastMonthStart);
                                              setEndDate(lastMonthEnd);
                                            }}>
                                              Last Month
                                            </button>
                                           </div>
          {/* <div style={{marginRight: 10, width: 'fit-content'}}>
           <select className={`col-md-12 ${styles.contentBookingBranchSelect}`} value={propertyID} onChange={(e) => {
            setPropertyID(e.target.value)
            }}>
              <option value="366123786">Vietnam</option>
              <option value="474531943">Cambodia</option>
            </select>
            </div> */}
        
              {/* <div style={{marginRight: 10, width: 'fit-content'}}>
            <button className="base__btn btn--mobile"  onClick={() => getDataGA4()}>Get Data</button>
            </div> */}
         
        </div>
    </div>
      {isLoading && (
           <LoadingModal />
          )}
              
     {data && (
      <div>
         <div className="d-flex align-items-center" style={{marginTop: 20}}>
            <img src="https://cdn-icons-png.flaticon.com/512/732/732204.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
        <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Analytics Report</div>
        </div>
        <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Overall</div>
           <div className="container-fluid pl-5 pr-5" >
      <div className="row">
          <div className="col-md-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.ga4Reservation')} data-for="marketing">
               <StatCard
                isCompare
                height={320}
                fontTitle={40}
                fontValue={60}
                title="GA4 Reservation"
                previousData={compareData?.reservation?.previous}
                previousIcon={<LucideCalendarClock size={25} color="#fff" strokeWidth={3} />}
                value={Intl.NumberFormat('de-DE').format(reservationCompleted)}
                icon={<ConciergeBell size={20} color="#16a34a" />}
                checkColor={compareData?.reservation?.trend === 'up' ? "green" : "red"}
                checkIcon={compareData?.reservation?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}
                compare={compareData?.reservation?.percentChange}
                gradientFrom="#16a34a"
                gradientTo="#065f46"
              />
            <div>
          </div>
          </div>
        </div>
         <div className="col-md-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.webReservation')} data-for="marketing">
               <StatCard
                isCompare
                height={320}
                fontTitle={40}
                fontValue={60}
                title="Web Reservation"
                previousData={realReservation?.totalMonth2}
                previousIcon={<LucideCalendarClock size={25} color="#fff" strokeWidth={3} />}
                value={Intl.NumberFormat('de-DE').format(realReservation?.totalMonth1)}
                icon={<ConciergeBell size={20} color="#8b5cf6" />}
                checkColor={realReservation?.trend === 'up' ? "green" : "red"}
                checkIcon={realReservation?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}
                compare={realReservation?.percentChange}
                gradientFrom="#8b5cf6"
                gradientTo="#4c1d95"
              />
            <div>
          </div>
          </div>
        </div>
         <div className="col-md-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.totalUser')} data-for="marketing">
               <StatCard
               isCompare
                height={320}
                fontTitle={40}
                fontValue={60}
                title="Total Users"
                value={Intl.NumberFormat('de-DE').format(compareData?.overview?.totalUsers?.current)}
                icon={<Users size={20} color="#2563eb" />}
                previousData={Intl.NumberFormat('de-DE').format(compareData?.overview?.totalUsers?.previous)}
                previousIcon={<LucideCalendarClock size={25} color="#fff" strokeWidth={3} />}
                checkColor={compareData?.overview?.totalUsers?.trend === 'up' ? "green" : "red"}
                checkIcon={compareData?.overview?.totalUsers?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}
                compare={Math.abs(compareData?.overview?.totalUsers?.percentChange)}
                gradientFrom="#2563eb"
                gradientTo="#1e3a8a"
              />
        </div>
        </div>
         {/* <div className="col-md-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.totalUser')} data-for="marketing">
               <StatCard
               isCompare
                height={320}
                fontTitle={40}
                fontValue={60}
                title="News Users"
                value={Intl.NumberFormat('de-DE').format(compareData?.overview?.newUsers?.current)}
                icon={<Users size={20} color="#2563eb" />}
                previousData={Intl.NumberFormat('de-DE').format(compareData?.overview?.newUsers?.previous)}
                previousIcon={<LucideCalendarClock size={25} color="#fff" strokeWidth={3} />}
                checkColor={compareData?.overview?.newUsers?.trend === 'up' ? "green" : "red"}
                checkIcon={compareData?.overview?.newUsers?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}
                compare={Math.abs(compareData?.overview?.newUsers?.percentChange)}
                gradientFrom="#2563eb"
                gradientTo="#1e3a8a"
              />
        </div>
        </div> */}
           <div className="col-md-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.session')} data-for="marketing">
               <StatCard
               isCompare
                height={320}
                fontTitle={40}
                fontValue={60}
                title="Sessions"
                value={Intl.NumberFormat('de-DE').format(compareData?.overview?.sessions?.current)}
                icon={<Clock size={20} color="#FF8A00" />}
                 previousData={Intl.NumberFormat('de-DE').format(compareData?.overview?.sessions?.previous)}
                previousIcon={<LucideCalendarClock size={25} color="#fff" strokeWidth={3} />}
                checkColor={compareData?.overview?.sessions?.trend === 'up' ? "green" : "red"}
                checkIcon={compareData?.overview?.sessions?.trend === 'up' ? <LucideArrowUp size={30} color="green" strokeWidth={3} /> : <LucideArrowDown size={30} color="red" strokeWidth={3}/>}
                compare={Math.abs(compareData?.overview?.sessions?.percentChange)}
                gradientFrom="#ffa743"
                gradientTo="#b3350f"
              />
        </div>
        </div>
        <div style={{marginTop: 50}}></div>
           <div className="col-md-3 p-3">
            <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.pageView')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Page Views"
                value={pageViewCount}
                icon={<Eye size={20} color="#7b00ff" />}
                gradientFrom="#d8b4fe"
                gradientTo="#a78bfa"
              />
        </div>
        </div>
           <div className="col-md-3 p-3">
          <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.eventCount')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Event Count"
                value={eventCount}
                icon={<Calendars size={20} color="#ff001e" />}
                gradientFrom="#fecdd3"
                gradientTo="#fda4af"
              />
        </div>
        </div>
           <div className="col-md-3 p-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.desktop')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Desktop"
                value={deviceStats.desktop}
                icon={<Monitor size={20} color="#00a6ff" />}
                gradientFrom="#bae6fd"
                gradientTo="#bae6fd"
              />
        </div>
        </div>
           <div className="col-md-3 p-3">
          <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.mobile')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Mobile"
                value={deviceStats.mobile}
                icon={<Smartphone size={20} color="#ffcc00" />}
                gradientFrom="#fde68a"
                gradientTo="#fcd34d"
              />
        </div>
        </div>
        <div className="col-md-3 p-3">
          <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.city')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="City"
                value={(Object.keys(cityStats).length - 1)}
                icon={<Building2 size={20} color="#00ffc3" />}
                gradientFrom="#7CF5D8"
                gradientTo="#4FD1C5"
              />
            <div>
          </div>
          </div>
        </div>
          <div className="col-md-3 p-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.country')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Country"
                value={(Object.keys(countryStats).length - 1)}
                icon={<Earth size={20} color="#2f00ff" />}
                gradientFrom="#A18CFF"
                gradientTo="#6C63FF"
              />
            <div>
          </div>
          </div>
        </div>
         
           <div className="col-md-3 p-3">
            <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.browser')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Browser"
                value={Object.keys(browserStats).length}
                icon={<Globe size={20} color="#ff4800" />}
                gradientFrom="#faaf92"
                gradientTo="#ec7577"
              />
        </div>
        </div>
          <div className="col-md-3 p-3">
           <div className={`${stylesReport.cardWrapper}`} data-tip={t('marketing.ga4.os')} data-for="marketing">
               <StatCard
               height={200}
               fontTitle={20}
               fontValue={35}
               color={"#1e293b"}
                title="Operating System"
                value={Object.keys(osStats).length}
                icon={<Cog size={20} color="#0011ff" />}
                gradientFrom="#858df7"
                gradientTo="#5a67c9"
              />
        </div>
        </div>
        <ReactTooltip id = 'marketing' style={{
                 fontSize: 20,
                 maxWidth: 400,
                 whiteSpace: "pre-line",
                 backgroundColor: "#000",
                 borderRadius: 10,
                 zIndex: 99999
               }}/>


      </div>
    </div>
       <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Detail</div>
        <div className="container-fluid">
          <div className="row">
          <div className="col-md-6">
              <div style={paginationContainerStyle}>
          <button
            onClick={goPrev1}
            disabled={currentPage1 === 1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage1 === 1 && paginationBtnDisabledStyle),
            }}
          >
            «
          </button>

          <span style={paginationTextStyle}>
            Page {currentPage1} / {totalPages1}
          </span>

          <button
            onClick={goNext1}
            disabled={currentPage1 === totalPages1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage1 === totalPages1 &&
                paginationBtnDisabledStyle),
            }}
          >
            »
          </button>
        </div>
            <table className="table" style={{...tableStyle}}>
              <thead style={{ background: "#f5f5f5" }}>
                <tr>
                  <th style={{...thStyle, ...stickyHeader}}>No</th>
                  <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.country')} data-for="marketing">Country</th>
                   <th style={{...thStyle, ...stickyHeader}}>
                    <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                                <span>Conversions</span>
                                <div className="d-flex flex-column">
                                  <button
                                    className="btn-sort"
                                    onClick={() => setSortType("conversion-asc")}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, opacity: sortType === "conversion-asc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                  <button
                                    className="btn-sort"
                                    onClick={() => setSortType("conversion-desc")}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10, opacity: sortType === "conversion-desc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                </div>
                              </div>
                  </th>
                  <th style={{...thStyle, ...stickyHeader}}>
                    <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.ga4.session')} data-for="marketing"> 
                                <span>Sessions</span>
                                <div className="d-flex flex-column">
                                  <button
                                    className="btn-sort"
                                    onClick={() => {
                                      setSortType("session-asc")
                                    }}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, opacity: sortType === "session-asc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                  <button
                                    className="btn-sort"
                                    onClick={() => {
                                      setSortType("session-desc")
                                    }}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10, opacity: sortType === "session-desc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                </div>
                              </div>
                  </th>
                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.googleAds.cvr')} data-for="marketing">
                  CVR
                </th>
                </tr>
              </thead>
              <tbody>
          {currentData1
                ?.filter(
                  row =>
                    row &&
                    row.dimensionValues?.length &&
                    row.metricValues?.length >= 3
                )
                .map((row, idx) => (
                  <tr key={idx}>
                    <td style={tdStyle}>{idx + 1}</td>
                    <td style={tdStyle}>{row.dimensionValues[0]?.value ?? "-"}</td>
                    <td style={tdStyle}>{row.metricValues[1]?.value ?? 0}</td>
                    <td style={tdStyle}>{row.metricValues[0]?.value ?? 0}</td>
                    <td style={tdStyle}>
                      {(Number(row.metricValues[2]?.value ?? 0) * 100).toFixed(2)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
            <div className="col-md-6">
              <div style={paginationContainerStyle}>
          <button
            onClick={goPrev2}
            disabled={currentPage2 === 1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage2 === 1 && paginationBtnDisabledStyle),
            }}
          >
            «
          </button>

          <span style={paginationTextStyle}>
            Page {currentPage2} / {totalPages2}
          </span>

          <button
            onClick={goNext2}
            disabled={currentPage2 === totalPages2}
            style={{
              ...paginationBtnStyle,
              ...(currentPage2 === totalPages2 &&
                paginationBtnDisabledStyle),
            }}
          >
            »
          </button>
        </div>
            <div>
            <table className="table" style={{...tableStyle}}>
              <thead style={{ background: "#f5f5f5" }}>
                <tr>
                  <th style={{...thStyle, ...stickyHeader}}>No</th>
                  <th style={{...thStyle, ...stickyHeader}}>City</th>
                    <th style={{...thStyle, ...stickyHeader}}>
                    <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                                <span>Conversions</span>
                                <div className="d-flex flex-column">
                                  <button
                                    className="btn-sort"
                                    onClick={() => setSortType2("conversion-asc")}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, opacity: sortType2 === "conversion-asc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                  <button
                                    className="btn-sort"
                                    onClick={() => setSortType2("conversion-desc")}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10, opacity: sortType2 === "conversion-desc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                </div>
                              </div>
                  </th>
                  <th style={{...thStyle, ...stickyHeader}}>
                    <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.ga4.session')} data-for="marketing">
                                <span>Sessions</span>
                                <div className="d-flex flex-column">
                                  <button
                                    className="btn-sort"
                                    onClick={() => {
                                      setSortType2("session-asc")
                                    }}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, opacity: sortType2 === "session-asc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                  <button
                                    className="btn-sort"
                                    onClick={() => {
                                      setSortType2("session-desc")
                                    }}
                                    style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10, opacity: sortType2 === "session-desc" ? 1 : 0.5}}
                                  >
                                    <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                                  </button>
                                </div>
                              </div>
                  </th>
                
                <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.googleAds.cvr')} data-for="marketing">
                  CVR
                </th>
                </tr>
              </thead>
              <tbody>
          {currentData2
                ?.filter(
                  row =>
                    row &&
                    row.dimensionValues?.length &&
                    row.metricValues?.length >= 3
                )
                .map((row, idx) => (
                  <tr key={idx}>
                    <td style={tdStyle}>{idx + 1}</td>
                    <td style={tdStyle}>{row.dimensionValues[0]?.value ?? "-"}</td>
                    <td style={tdStyle}>{row.metricValues[1]?.value ?? 0}</td>
                    <td style={tdStyle}>{row.metricValues[0]?.value ?? 0}</td>
                    <td style={tdStyle}>
                      {(Number(row.metricValues[2]?.value ?? 0) * 100).toFixed(2)}%
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            </div>
          </div>
          </div>

        </div>
         <div style={paginationContainerStyle}>
          <button
            onClick={goPrev}
            disabled={currentPage === 1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage === 1 && paginationBtnDisabledStyle),
            }}
          >
            «
          </button>

          <span style={paginationTextStyle}>
            Page {currentPage} / {totalPages}
          </span>

          <button
            onClick={goNext}
            disabled={currentPage === totalPages}
            style={{
              ...paginationBtnStyle,
              ...(currentPage === totalPages &&
                paginationBtnDisabledStyle),
            }}
          >
            »
          </button>
        </div>
                            <div className="container-fluid">
                              <div className="row">
                                <div className="col-md-12">
 <table style={{...tableStyle}}>
          <thead style={{ background: "#f5f5f5" }}>
            <tr>
              <th style={{...thStyle, ...stickyHeader}}>Date</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.pagePath')} data-for="marketing">PagePath</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.city')} data-for="marketing">City</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.country')} data-for="marketing">Country</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.device')} data-for="marketing">Device</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.browser')} data-for="marketing">Browser</th>
              <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.ga4.os')} data-for="marketing">Operating System</th>
            </tr>
          </thead>

          <tbody>
            {currentData
            ?.filter((item) => item.city !== "(not set)")
            ?.map((row, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                <td style={tdStyle}>{row.dimensionValues[0]?.value}</td>
                <td style={{ ...tdStyle, maxWidth: 200 }}>{row.dimensionValues[6]?.value}</td>
                <td style={tdStyle}>{row.dimensionValues[2]?.value}</td>
                <td style={tdStyle}>{row.dimensionValues[1]?.value}</td>
                <td style={tdStyle}>{row.dimensionValues[3]?.value}</td>
                <td style={tdStyle}>{row.dimensionValues[4]?.value}</td>
                <td style={tdStyle}>{row.dimensionValues[5]?.value}</td>
            
              </tr>
            ))}
          </tbody>
        </table>
                                </div>
                              </div>
                            </div>
       
      </div>
      )}

    </div>
  );
}
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  borderRadius: 16,
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  backgroundColor: "#fff",
  tableLayout: "auto",
  marginTop: 10
};
const thStyle = {
  padding: "14px 16px",
  textAlign: "center",
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: "0.5px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  fontSize: 18,
  color: "#333",
  backgroundColor: "#fff",
  cursor: "pointer",
  whiteSpace: "nowrap", 
};
const stickyHeader = {
  fontSize: 16,
  position: 'sticky',top: 80,
  zIndex: 999
};

const paginationContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 14,
  width: "fit-content",
  marginTop: 20,
  padding: "10px 16px",
  borderRadius: 16,
  background: "#fff",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
};

const paginationBtnStyle = {
  height: 42,
  width: 42,
  border: "none",
  borderRadius: 12,
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.25s ease",
  boxShadow: "0 4px 10px rgba(108, 74, 182, 0.25)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const paginationBtnDisabledStyle = {
  background: "#f3f4f6",
  color: "#9ca3af",
  cursor: "not-allowed",
  boxShadow: "none",
};

const paginationTextStyle = {
  fontSize: 16,
  fontWeight: 600,
  color: "#482979",
  whiteSpace: "nowrap",
};




